import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconCheckSmallLine = ({ width = 32, height = 32, fill = '#1D2225', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3333 18.1333L21.2 10.2667C21.4444 10.0222 21.7556 9.9 22.1333 9.9C22.5111 9.9 22.8222 10.0222 23.0667 10.2667C23.3111 10.5111 23.4333 10.8222 23.4333 11.2C23.4333 11.5778 23.3111 11.8889 23.0667 12.1333L14.2667 20.9333C14 21.2 13.6889 21.3333 13.3333 21.3333C12.9778 21.3333 12.6667 21.2 12.4 20.9333L8.93333 17.4667C8.68889 17.2222 8.56667 16.9111 8.56667 16.5333C8.56667 16.1556 8.68889 15.8444 8.93333 15.6C9.17778 15.3556 9.48889 15.2333 9.86667 15.2333C10.2444 15.2333 10.5556 15.3556 10.8 15.6L13.3333 18.1333Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconCheckSmallLine;
